import type { Step } from '../StepItem';
import type { StepperColors } from '../types';

interface ConnectorLineProps {
    isHorizontal: boolean;
    nextStepStatus: Step['status'] | undefined;
    colors: StepperColors;
    dataTestId?: string;
}

const HORIZONTAL_SVG = {
    width: '22',
    height: '2',
    viewBox: '0 0 22 2',
    path: 'M0.5 1L11 1L21.5 1',
};
const VERTICAL_SVG = {
    width: '2',
    height: '27',
    viewBox: '0 0 2 27',
    path: 'M1 0.5L1 13.5L1 26.5',
};

const ConnectorLine = ({
    isHorizontal,
    nextStepStatus,
    colors,
    dataTestId,
}: ConnectorLineProps) => {
    const isNextStepReached = nextStepStatus === 'completed' || nextStepStatus === 'active';
    const strokeColor = isNextStepReached ? colors.completedConnector : colors.upcomingConnector;
    const svgDimensions = isHorizontal ? HORIZONTAL_SVG : VERTICAL_SVG;

    return (
        <div
            data-testid={dataTestId}
            className={`flex ${isHorizontal ? 'h-auto w-full items-center' : 'h-10 items-center justify-center'}`}
            style={{ color: strokeColor }}
        >
            <svg
                width={svgDimensions.width}
                height={svgDimensions.height}
                viewBox={svgDimensions.viewBox}
                fill={'none'}
                className={isHorizontal ? '' : 'scale-150'}
            >
                <path
                    d={svgDimensions.path}
                    stroke={'currentColor'}
                    strokeWidth={'2'}
                    strokeMiterlimit={'1.22077'}
                    strokeDasharray={'1 1'}
                    strokeDashoffset={'0.5'}
                />
            </svg>
        </div>
    );
};

export { ConnectorLine };
export type { ConnectorLineProps };
